import styled, { css } from 'styled-components';
import { TButtonProps } from './types';

import {
  COLOR_BUTTON_PRIMARY,
  COLOR_BUTTON_PRIMARY_070,
  COLOR_BLUE_020,
  COLOR_RED,
  COLOR_WHITE,
} from '@common/assets/styles/colors';

export const SuffixSC = styled.div`
  position: absolute;
  right: 7%;
  max-height: 100%;
`;
export const PrefixSC = styled.div`
  position: absolute;
  left: 7%;
  max-height: 100%;
`;

export const ButtonSC = styled.button<TButtonProps>`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  text-transform: uppercase;
  border: none;
  cursor: pointer;
  transition: 0.2s background-color;
  white-space: nowrap;
  line-height: 1;

  svg {
    display: inline !important;
  }

  &:hover,
  &:focus {
    text-decoration: none;
    outline: none;
    background-color: ${COLOR_BUTTON_PRIMARY_070};
  }

  // ???
  &:disabled {
    background-color: ${COLOR_BLUE_020};
    cursor: not-allowed;
  }

  ${({ isBlock }) => {
    if (isBlock) {
      return css`
        display: block;
        width: 100%;
      `;
    }
  }}

  ${({ size, shape }) => {
    switch (size) {
      case 'small':
        return css`
          padding: 0 26px;
          height: 24px;
          border-radius: 5px;
          ${shape === 'round'
            ? css`
                height: 24px;
                border-radius: 12px;
                padding: 2px;
              `
            : ''}
        `;

      case 'medium':
        return css`
          padding: 0 26px;
          height: 30px;
          border-radius: 5px;
          ${shape === 'round'
            ? css`
                height: 30px;
                border-radius: 15px;
                padding: 13px;
              `
            : ''}
        `;
      case 'large':
        return css`
          padding: 0 30px;
          height: 40px;
          border-radius: 10px;
          ${shape === 'round'
            ? css`
                height: 40px;
                border-radius: 20px;
                padding: 15px;
              `
            : ''}
        `;
      default:
        return css`
          padding: 0 24px;
          height: 50px;
          border-radius: 10px;
          ${shape === 'round'
            ? css`
                height: 50px;
                border-radius: 25px;
                padding: 12px;
              `
            : ''}
        `;
    }
  }}



  ${({ variation }) => {
    switch (variation) {
      case 'primary':
        return css`
          color: ${COLOR_WHITE};
          background: ${COLOR_BUTTON_PRIMARY};
        `;
      case 'warn':
        return css`
          color: ${COLOR_WHITE};
          background: ${COLOR_RED};
        `;
      case 'link':
        return css`
          color: #181e34;
          background: transparent;

          &:hover {
            text-decoration: underline;
          }
        `;
      default:
        return css`
          color: #323d6f;
          background: #eaebf0;
        `;
    }
  }}
`;
